import { useState } from "react";
const usePopoverState = (defaultOpen) => {
  const [open, onOpenChange] = useState(!!defaultOpen);
  return {
    open,
    onOpenChange,
    defaultOpen: !!defaultOpen
  };
};
export {
  usePopoverState
};
//# sourceMappingURL=usePopoverState.js.map
